/**
 * Determines the luminosity of the background image or colour and assigns a class to an element based on
 * the result.
 *
 */


(function ( $ ) {

	const debug_enabled = true;

	/**
	 * Get background color or image.
	 *
	 * @param element
	 * @return {*|Promise}
	 */
	function getBackgroundColorOrImage( element ) {

	  // First check if element is an img tag
	  if (element.tagName.toLowerCase() === 'img') {
	    // Check if image has valid src
	    if (element.src && element.complete && element.naturalHeight !== 0) {
	      return getAverageColorFromImage(element, element.src);
	    }
	    return Promise.resolve(null);
	  }

		// From now on, assuming we are working with an element that uses images and colours as CSS properties
		const style           = getComputedStyle( element );
		const backgroundImage = style.backgroundImage;
		const backgroundColor = style.backgroundColor;

		// If there's a background image, return the average color from the image
		if ( backgroundImage && backgroundImage !== 'none' ) {
			return getAverageColorFromImage( element, backgroundImage );
		}

		// If there's a background color, return it (parsed as needed)
		if ( backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent' ) {
			return Promise.resolve( parseColor( backgroundColor ) );
		}

		// If neither image nor color exists, return null
		return Promise.resolve( null );
	}

	/**
	 * Parse RGB color from 'background-color' CSS property
	 *
	 * @param color
	 * @return {{r: *, b: *, g: *}}
	 */
	function parseColor( color ) {
		const rgb = color.match( /\d+/g ).map( Number );
		return { r: rgb[ 0 ], g: rgb[ 1 ], b: rgb[ 2 ] };
	}

	/**
	 * Get average color from the top 75px of the background image
	 */
	function getAverageColorFromImage( element, backgroundImage ) {
		return new Promise( ( resolve ) => {
			const img    = new Image();
			const canvas = document.createElement( 'canvas' );
			const ctx    = canvas.getContext( '2d' );

			let imageUrl = backgroundImage.replace( /url\((['"])?(.*?)\1\)/gi, '$2' );
			imageUrl     = imageUrl.replace( /['"]/g, '' ).trim();

			// Remove any query parameters that might interfere
			imageUrl        = imageUrl.split( '?' )[ 0 ];
			img.crossOrigin = ""; // Attempt to load the image with CORS enabled
			img.src         = imageUrl;

			img.onload = () => {
				const width  = element.clientWidth;
				const height = Math.min( 75, img.height ); // Limit to top 75px

				canvas.width  = width;
				canvas.height = height;

				ctx.drawImage( img, 0, 0, width, height, 0, 0, width, height );

				try {
					const imgData = ctx.getImageData( 0, 0, width, height );
					const pixels  = imgData.data;
					let r         = 0, g = 0, b = 0;

					// Loop through every 5th pixel in the top 75px
					for ( let i = 0; i < pixels.length; i += 4 * 5 ) { // Skipping 4 * 5 bytes (RGBA for each pixel)
						r += pixels[ i ];     // Red
						g += pixels[ i + 1 ]; // Green
						b += pixels[ i + 2 ]; // Blue
					}

					const totalPixels = pixels.length / (4 * 5);
					resolve( {
						r: r / totalPixels,
						g: g / totalPixels,
						b: b / totalPixels
					} );
				} catch ( error ) {
					debug_enabled && console.error( '[luminosity]: Canvas is tainted due to cross-origin image', error );
					resolve( null ); // Resolve with null if canvas is tainted
				}
			};

			img.onerror = ( err ) => {
				debug_enabled && console.error( '[luminosity]: Failed to load image:', err );
				resolve( null ); // Resolve with null if image fails to load
			};
		} );
	}

	/**
	 * Calculate luminosity from RGB
	 *
	 * @param color
	 * @return {number}
	 */
	function calculateLuminosity( color ) {
		if ( null === color ) {
			return 0;
		}
		const { r, g, b } = color;
		return 0.2126 * r + 0.7152 * g + 0.0722 * b; // Standard luminosity formula
	}

	/**
	 * Find the image to use for the calculations.
	 *
	 * @return {*|null}
	 */
	function getImageDomElement() {

		// Whack a mole #1: taxonomy archive pages
		if ( $( 'body' ).hasClass( 'taxonomy_archive_root' ) ) {
			debug_enabled && console.log( "[luminosity]: .taxonomy_archive_root found" );
			let $imageBackground = $( ".site-container .site-inner .ra-hero--image" );
			// If found, return the DOM element (not jQuery object), otherwise return null
			return $imageBackground.length ? $imageBackground[ 0 ] : null;
		}

		// Whack a mole #2: taxonomy term pages
		else if ( $( 'body' ).hasClass( 'is_tax' ) ) {
			debug_enabled && console.log( "[luminosity]: .is_tax found" );
			let $imageBackground = $( ".site-container .site-inner .ra-hero--image" );
			// If found, return the DOM element (not jQuery object), otherwise return null
			return $imageBackground.length ? $imageBackground[ 0 ] : null;

		// Whack a mole #3: post type archive pages
		} else if ( $( 'body' ).hasClass( 'post-type-archive' ) ) {
			debug_enabled && console.log( "[luminosity]: .post-type-archive" );
			let $imageBackground = $( ".site-container .site-inner .ra-hero--image" );
			// If found, return the DOM element (not jQuery object), otherwise return null
			return $imageBackground.length ? $imageBackground[ 0 ] : null;
		}
		// Whack a mole #4: pages with a header image
		else if ( $( 'body' ).hasClass( 'leadership' ) ) {
			debug_enabled && console.log( "[luminosity]: .leadership" );
			let $imageBackground = $( ".site-container .site-inner .ra-hero--image" );
			// If found, return the DOM element (not jQuery object), otherwise return null
			return $imageBackground.length ? $imageBackground[ 0 ] : null;
		}

		// Whack a mole #5: some pages insert the header image outside .entry-content
		else if ( $( '.site-inner' ).children( '.wrap' ).first().children('.ra-hero--image').first().length ) {
			debug_enabled && console.log( "[luminosity]: .outside of entry-content" );
			let $imageBackground = $( ".site-container .site-inner > .wrap > .ra-hero--image" );
			// If found, return the DOM element (not jQuery object), otherwise return null
			return $imageBackground.length ? $imageBackground[ 0 ] : null;
		}


			// The Rest: standard pages that use a block
		else {
			var $entryContent = $( '.entry-content' );

			// Check if the first child of .entry-content is a .wp-block-cover element
			var $firstCover = $entryContent.children( '.wp-block-cover' ).first();

			if ( $firstCover.length ) {
				// Check if .wp-block-cover__image-background is a child of the .wp-block-cover
				var $imageBackground = $firstCover.find( '.wp-block-cover__image-background' );

				// If found, return the DOM element (not jQuery object), otherwise return null
				return $imageBackground.length ? $imageBackground[ 0 ] : null;
			}
		}
		return null;
	}

	/**
	 * Takes the ID of an element and determines the background image or (if no image) the background
	 * colour, determines the luminosity, and assigns the appropriate class to the element with the
	 * supplied ID based on what it finds.
	 *
	 *
	 * @param imageEl           Element with the background colour or image
	 * @param targetEl          Element to set the class on
	 * @param darkClass         Class to use when the luminosity is determined to be dark
	 * @param lightClass        Class to use when the luminosity is determined to be light
	 * @param threshold         Int from 0-255 that provides the luminosity cutoff from light to dark. Default 128
	 */
	function assignLuminosityTo( imageEl, targetEl, darkClass, lightClass, threshold = 128 ) {
		getBackgroundColorOrImage( imageEl ).then( color => {
			if ( color === null ) {
				return;
			}
			const luminosity = calculateLuminosity( color );
			if ( luminosity > threshold ) {
				targetEl.classList.add( lightClass );
			} else {
				targetEl.classList.add( darkClass );
			}
		} );
	}


	/**
	 * Sets the dark or light class on the main nav element based on the luminosity of the main
	 * header block's background image.
	 *
	 * @param threshold                Int from 0-255 that provides the luminosity cutoff from light to dark. Default 128
	 */
	function assignLuminosityToSiteHeaderBasedOnBackground( threshold = 128 ) {
		const element = getImageDomElement();
		if ( null === element ) {
			debug_enabled && console.log( "[luminosity]: no image found; no change made." );
			return;
		}
		const luminosityIsDarkClass = 'luminosity-dark';
		const defaultLightClass     = 'luminosity-light'

		getBackgroundColorOrImage( element ).then( color => {
			if ( null === color ) {
				debug_enabled && console.log( "[luminosity]: no image found; no change made." );
				return;
			}
			const luminosity = calculateLuminosity( color );
			const targetEl   = document.getElementById( 'js-site-header' ); // Single DOM lookup

			// No need to check for other case since that is default
			if ( luminosity < threshold ) {
				debug_enabled && console.log( "[luminosity]: Image is dark (" + luminosity + "); '" + luminosityIsDarkClass + "' class assigned to #site-header" );
				targetEl.classList.add( luminosityIsDarkClass );
				targetEl.classList.remove( defaultLightClass );
			} else {
				debug_enabled && console.log( "[luminosity]: Image is light (" + luminosity + "); no change made." );
			}
		} );
	}

	// Expose assignLuminosityTo function globally
	window.assignLuminosityTo                            = assignLuminosityTo;
	window.assignLuminosityToSiteHeaderBasedOnBackground = assignLuminosityToSiteHeaderBasedOnBackground;
})( jQuery );
